import Splide from "@splidejs/splide"

const sliders = {
  init() {
    this.setCatSliders()
    this.setSubCatSliders()
    this.resetSlider()
    this.setProdSliders()
    this.setBlogSliders()
    this.setProdThumbnailsSlider()
  },
  resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider()
    })
  },
  setProdSliders() {
    const sliers = document.querySelectorAll(".jsProdSlider") as NodeListOf<HTMLElement>
    sliers.forEach((el) => {
      new Splide(el, {
        perPage: 5,       
        pagination: false,
        speed: 800,
        gap: "40px",

        breakpoints: {
          800: {
            perPage: 2,
          },
          500: {
            padding: { right: "23%" },
            perPage: 1,
            gap: "20px",
          },
        },
      }).mount()
    })
  },
  setBlogSliders() {
    const sliers = document.querySelectorAll(".jsBlogSlider") as NodeListOf<HTMLElement>
    sliers.forEach((el) => {
      new Splide(el, {
        perPage: 4,
        type: "loop",
        pagination: false,
        speed: 800,
        gap: "30px",

        breakpoints: {
          800: {
            perPage: 2,
          },
          500: {
            padding: { right: "23%" },
            perPage: 1,
            gap: "20px",
          },
        },
      }).mount()
    })
  },
  setCatSliders() {
    const cats = document.querySelectorAll(".jsProdCatSlider") as NodeListOf<HTMLElement>
    cats.forEach((el) => {
      new Splide(el, {
        perPage: 5,
        type: "loop",
        arrows: true,
        pagination: false,
        speed: 800,
        gap: "30px",
        breakpoints: {
          800: {
            perPage: 3,
          },
          500: {
            gap: "25px",
            padding: { left: "0", right: "33%" },
            perPage: 1,
          },
        },
      }).mount()
    })
  },

  setSubCatSliders() {
    const cats = document.querySelectorAll(".jsProdSubCatSlider") as NodeListOf<HTMLElement>
    cats.forEach((el) => {
      new Splide(el, {
        perPage: 5,
       
        arrows: true,
        pagination: false,
        speed: 800,
        gap: "30px",
        breakpoints: {
          920: {
            perPage: 2,
          },
          500: {
            gap: "25px",
            padding: { left: "0", right: "33%" },
            perPage: 1,
          },
        },
      }).mount()
    })
  },

  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      })

      const thumbnailsNav = new Splide(thumbnails, {
        isNavigation: true,
        pagination: false,
        perPage: 3,
        arrows: false,
        gap: "17px",
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },
}

export default sliders
